import { DropTarget } from 'react-dnd';
import { compose } from 'recompose';
import { contains, pipe, prop, propOr } from 'ramda';

import { IInner, IOuter } from './DropZone.types';
import { createFilesBiOptionsMap } from '../../../utils/bi';
import { createFolderStructure, extractFile, getAllDroppedFiles } from './fileEntry';
import { applyDenyList, fixEmptyTypes } from './utils';
import { withUploadQueueObservables } from '../../../utils/hooks/useFilesUploader/useFilesUploader';

export const enhance = compose<IInner, IOuter>(
  withUploadQueueObservables,
  DropTarget<IOuter>(
    prop('accepts'),
    {
      drop: (props, monitor) => {
        const { disabled, onDrop, item, biTarget, biOrigin, createFolderFn, currentFolder, folderUploadedObservable } =
          props;

        if (disabled || monitor.didDrop()) {
          return;
        }

        if (onDrop) {
          const dropResult = monitor.getItem();

          if (dropResult.draggingItems || !DataTransferItem.prototype.webkitGetAsEntry) {
            const files = dropResult.draggingItems || dropResult.files;
            onDrop(files, item, {
              bi: {
                files: createFilesBiOptionsMap(files, biOrigin, biTarget),
              },
            });
          } else {
            getAllDroppedFiles(dropResult.items).then(({ files, folders }) => {
              const createFolderAndNotify = (folder) =>
                createFolderFn(folder).then((response) => {
                  folderUploadedObservable.next({ serverResponse: response });
                  return response;
                });
              (createFolderFn // drop on trash, etc
                ? createFolderStructure(folders, currentFolder, createFolderAndNotify)(files)
                : Promise.resolve(extractFile(files))
              ).then((allFiles) => {
                const files = pipe(applyDenyList, fixEmptyTypes)(allFiles);
                // @ts-expect-error
                return onDrop(files, item, {
                  bi: {
                    files: createFilesBiOptionsMap(files, biOrigin, biTarget),
                  },
                });
              });
            });
          }
        }
      },
      canDrop(props, monitor) {
        const isDisabled = props.disabled;
        const isDragged = contains(props.item, propOr([], 'draggingItems', monitor.getItem()));

        return !isDisabled && !isDragged;
      },
    },
    (connect, monitor) => ({
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver({ shallow: true }),
      canDrop: monitor.canDrop(),
    }),
  ),
);
